import { Component, OnInit ,ViewChild,ElementRef} from '@angular/core';
import { LibraryService, Dropobj } from '../../services/library.service';

import { HttpClient } from '@angular/common/http';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import { ChartType } from 'chart.js';
import { MultiDataSet } from 'ng2-charts';
import { ChartDataSets , RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {  ChartOptions } from 'chart.js';
import { Color} from 'ng2-charts';

@Component({
  selector: 'app-ioregister',
  templateUrl: './ioregister.component.html',
  styleUrls: ['./ioregister.component.scss'],
  providers:[LibraryService]
})
export class IoregisterComponent implements OnInit {

  memberdetails:any[]=[];
   bookdetails:any[]=[];
   issuedetails:any[]=[];
   issuedetails1:any[]=[];
   arrdaily:any=[];
   arrmonthly:any=[];
   closeResult: string;
   modalOptions:NgbModalOptions;
   private modalRef: NgbModalRef;
   selitem:any={};
   selbook:any={};
   selmember:any={};
   dashcounts:any={};
   booksmodel:any={};
   objvisitcnt:any={};
   crpmodel:any={};
    value: Date;
    isLoadingResult: boolean;
    memno:any='';
    memexist: boolean=false;
    visitorexist: boolean=false;
    fserdt:any;
    fserdt4:any;
 
    barChartData:ChartDataSets[]=[{data:[]}];
    barChartData1:ChartDataSets[]=[{data:[]}];
  admdash: any;
   constructor(private http: HttpClient, private liservice: LibraryService,private modalService: NgbModal) {
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
       size:'sm'
     }
 
    
    }
    @ViewChild('dt') dt: ElementRef;
  
   ngOnInit(): void {
     //this.Dasheadcounts();
     //this.dataview();
     this.setfirstdate();
    //  this.getlibvisitordashcounts();
    
    //  this.chartwalkins('chartdailywalkin');
   }
   keyword = 'name';
   keyword1 = 'title';
   acYears = [
     {value: 'return', viewValue: 'Return'},
     {value: 'renew', viewValue: 'Renew'},
   
   ];
 
   arrstatus = [
     {value: 'All', name: 'All'},
     {value: 'Walkin', name: 'Walkin'},
     {value: 'Online', name: 'Online'},
   
   ];
 
   arrmemtype = [
     {value: 'All', name: 'All'},
     {value: 'staff', name: 'Staff'},
     {value: 'student', name: 'Student'},
   
   ];
   defmem='All';
   defchintype='All';

 
   barChartOptions: ChartOptions = {
     responsive: true,
   };
   barChartLabels: Label[] = [];
   barChartLabels1: Label[] = [];
   barChartType: ChartType = 'bar';
   barChartLegend = true;
   barChartPlugins = [];
   walkinChartLabels: Label[] = [];
   walkinChartData: ChartDataSets[] = [
     // { data: [45, 37, 60, 70, 46, 33], label: 'Best Fruits' }
   ];
 walkinChartColors: Color[] = [
     {
       
       backgroundColor: '#F1670D',
       
     },
     ,
     {
      
       backgroundColor: '#0033FF',
     },
   ];
   Dasheadcounts()
   {
       this.liservice.Getdashboarddata('dashcounts')
     .subscribe(
            resultArray =>{
    // this.liservice.Getdashboarddata('dashcounts')
       console.log('result-dashcounts',resultArray) ;
       this.dashcounts=resultArray[0];
 
 
       },
      error => console.log('Error :: ' + error)
   );
   }
 
   setfirstdate() {
     this.liservice.getsysdatetoday()
         .subscribe(
         resultArray => {
             console.log('getlibsource', resultArray);
             this.fserdt = resultArray;
             this.fserdt4 = resultArray;
             this.crpmodel.frdt=resultArray;
             this.crpmodel.todt=resultArray;
             this.getlibvisitorrecord();
             
         },
         error => console.log("Error :: " + error)
         )
   }
 
 
   onchangefilters()
 {
   debugger
 if(this.defmem=="All" )
 {
 
   this.issuedetails=this.issuedetails1;
 }
 else
 {
   this.issuedetails=this.issuedetails1.filter(item => item.memtype===this.defmem);
 }
 }
  
   visitorcheckin()
   {
 
     this.liservice.hosvisitorcheckin(this.memno)
     .subscribe(result => {
         console.log('ret',JSON.stringify(result));
         alert (result.message);
        // this.getallissuedbooks();
         if(result.status=='Success')
 {
  // this.memno=null;
  this.memexist=false;
 this.getlibvisitorrecord() ;
 this.dt.nativeElement.filterGlobal('', 'contains');
 //this.Refreshsummary();
 
 }
     });
   }
   checkin()
   {
     //alert(this.selbooktitle+'-'+this.selbookid);
     var id = 0;
     var subid = 0;
     var secid = 0;
     var retdt = '';
     var oprtype = 'checkin';
     
    
     let clcd=localStorage.getItem('clcd');
     let aycd=localStorage.getItem('aycd');
     console.log('selbook-SAVE', this.selmember);
     //console.log('selbook-SAVE', this.selbook);
     
     var asgnmtdata = {id: id,  oprtype: oprtype,memid:this.selmember.id,memtype:this.selmember.usrtag };
     console.log('asgnmtdata-SAVE', asgnmtdata);
     this.liservice.savelibvisitorrecord(asgnmtdata)
     .subscribe(result => {
         console.log('ret',JSON.stringify(result));
         alert (result.message);
        // this.getallissuedbooks();
         if(result.status=='Success')
 {
   let localmodref=this.modalRef;
 localmodref.close();
 this.getlibvisitorrecord() ;
 //this.Refreshsummary();
 
 }
 
 
 else{
 
 
 }
      
     }, error => 
     alert('error in connection')
     
     );
   }
 
   getlibvisitordashcounts() {
     this.liservice.getlibvisitordashcounts('visitorinfo')
         .subscribe(
         resultArray => {
             console.log('getlibsupplier', resultArray);
             this.dashcounts = resultArray[0];
            
         },
         error => console.log("Error :: " + error)
         )
   }
 
 checkout(id)
 {
   var asgnmtdata = {ioid: id,  oprtype: 'checkout',memid:0,memtype:'' };
   console.log('asgnmtdata-SAVE', asgnmtdata);
   this.liservice.hosvisitorcheckout(asgnmtdata)
   .subscribe(result => {
       console.log('ret',JSON.stringify(result));
       alert (result.message);
      // this.getallissuedbooks();
 this.getlibvisitorrecord() ;
 
        
   }, error => 
   alert('error in connection')
   
   );
 
 }
 
 getlibvisitorrecord() {
   debugger
   this.liservice.gethosvisitorrecord(this.fserdt,this.fserdt4)
       .subscribe(
       resultArray => {
           console.log('getlibvisitorrecord', resultArray);
           this.issuedetails = resultArray.libvisitorrecord;
           this.issuedetails1 = resultArray.libvisitorrecord;
            this.admdash=resultArray.studash;
           
       },
       error => console.log("Error :: " + error)
       )
 }
 
 dataview()
 {
 
   this.getvisitoverview('daily');
   this.getvisitoverview('monthly');
 }
 getvisitoverview(tag) {
   debugger
   this.liservice.getvisitoroverview(this.crpmodel.frdt,this.crpmodel.todt,tag)
       .subscribe(
       resultArray => {
           // console.log('getlibvisitorrecord', resultArray);
           if(tag=="daily")
           {
           this.arrdaily = resultArray;
           this.dailychart(resultArray);
           }
           else{
           this.arrmonthly = resultArray;
           this.monthlychart(resultArray);
           }
           this.issuedetails1 = resultArray;
           
           
       },
       error => console.log("Error :: " + error)
       )
 }
 exporthistory(oprtype){
   var clcd=localStorage.getItem('clcd');
   var aycd=localStorage.getItem('aycd');
 
    var url=this.liservice.callurl+"export/expvisithistory.php?clcd="+clcd+"&aycd="+aycd+"&oprtype="+oprtype+"&dtfrm="+this.fserdt+"&dtto="+this.fserdt4+"&chtype="+this.defchintype;
 
    window.open(url,'','_blank');
  }
 checkmember() {
   if(this.memno!="")
   {
   this.liservice.checkhosmemberrecord('checkstu',this.memno)
       .subscribe(
       resultArray => {
           console.log('checkmember', resultArray);
          if(resultArray[0].memcnt>=1)
          {
            this.memexist=true;
            this.checkvisitor();
          }
          else{
 
           this.memexist=false;
           alert("Member doesn't exists with this id");
          }
           
           
       },
       error => {console.log("Error :: " + error);
       this.memexist=false;
     }
       )
   }
 }
 
 checkvisitor() {
   this.liservice.checkhosmemberrecord('checkvis',this.memno)
       .subscribe(
       resultArray => {
           console.log('checkvisitor', resultArray);
           if(resultArray[0].memcnt>=1)
          {
            this.visitorexist=true;
          }
          else{
 
           this.visitorexist=false;
          }
           
           
       },
       error =>{ console.log("Error :: " + error);
       this.visitorexist=false;
     }
       )
 }
   onmemberselectEvent(item) {
     console.log('item',item);
     this.selmember=item;
    // this.getissueddetails();
     // do something with selected item
   }
  
   onmemberChangeSearch(sertxt) {
     debugger
     //alert('shivu');
     // fetch remote data from here
     // And reassign the 'data' which is binded to 'data' property.
     if(sertxt.query.length>=3) 
     {
     this.getmemberdetails('serchmem',sertxt.query);
     }
   }
 
   getmemberdetails(oprtype,sertxt) {
     this.liservice.getmemberdetails(oprtype,sertxt,0,0)
         .subscribe(
         resultArray => {
             console.log('members-result', resultArray);
             this.memberdetails = resultArray;
             
         },
         error => console.log("Error :: " + error)
         )
   }
 
 
 
   opencategory(content) {
     this.modalOptions = {
       backdrop:'static',
       backdropClass:'customBackdrop',
       //  size:'md'
      
     }
     this.modalRef=this.modalService.open(content,this.modalOptions);
     
     this.modalRef.result.then((result) => {
    
          
       }, (reason) => {
           
       });
   }
 
   chartwalkins(oprtype)
   {
     
     this.liservice.Getdashboarddata(oprtype)
     .subscribe(
       
      resultArray =>{
       console.log('result-'+oprtype,resultArray) ;
       //this.clsdate=resultArray;
       var arr = [];
       var issued = [];
       var returned = [];
       for ( var i = 0; i < resultArray.length ; i++) {
         //console.log('multiarray -i',JSON.stringify(i));
          
               
               arr.push(resultArray[i].date15);
               issued.push(parseInt( resultArray[i].issued)); // 
              // returned.push(parseInt( resultArray[i].returned));
               
              
       }
       // this.lineChartData = [
       //   { data: issued, label: 'Issued', 
       //   backgroundColor: "rgba(150,150,150,50)",borderColor: "rgba(220,220,220,2)"},
       //   { data: returned, label: 'Returned',
       //   backgroundColor: "rgba(151,187,205,0.2)",
       //   borderColor: "rgba(151,187,205,1)" },
       // ];
      this.walkinChartData = [
         { data: issued, label: 'Walkins', 
        },
         
       ];
        this.walkinChartLabels = arr;
     
      
       
       
      // this.dataSource = new MatTableDataSource(resultArray);
       },
      error => console.log("Error :: " + error)
   )
   }
 
 
 
 
   dailychart(arrdaily)
   {
    
     var resultArray=arrdaily;
       // console.log('Booksissue_received-'+oprtype,resultArray) ;
       //this.clsdate=resultArray;
       var arr = [];
       var issued = [];
       var returned = [];
       for ( var i = 0; i < resultArray.length ; i++) {
         //console.log('multiarray -i',JSON.stringify(i));
          
               
               arr.push(resultArray[i].dat);
               issued.push(parseInt( resultArray[i].stucnt)); // 
               returned.push(parseInt( resultArray[i].stfcnt));
               
              
       }
      
      this.barChartData = [
         { data: issued, label: 'Student', 
        },
         { data: returned, label: 'Staff',
          },
       ];
        this.barChartLabels = arr;
     
      
    
   }
   
 
   
   monthlychart(arrdaily)
   {
    
     var resultArray=arrdaily;
       // console.log('Booksissue_received-'+oprtype,resultArray) ;
       //this.clsdate=resultArray;
       var arr = [];
       var issued = [];
       var returned = [];
       for ( var i = 0; i < resultArray.length ; i++) {
         //console.log('multiarray -i',JSON.stringify(i));
          
               
               arr.push(resultArray[i].dat);
               issued.push(parseInt( resultArray[i].stucnt)); // 
               returned.push(parseInt( resultArray[i].stfcnt));
               
              
       }
      
      this.barChartData1 = [
         { data: issued, label: 'Student', 
        },
         { data: returned, label: 'Staff',
          },
       ];
        this.barChartLabels1 = arr;
     
      
    
   }
 
 }
 
